import axiosInstance from 'api/axiosConfig'
import handleApiError from 'api/utils/handleApiError';
import { ListedProperty } from 'types/property'

import { ENDPOINTS } from '../endpoints'

const useFavoritesService = () => {
  const loadFavorites = async (): Promise<ListedProperty[]> => {
    try {
      const response = await axiosInstance.get(
        ENDPOINTS.FAVORITES.LOAD_FAVORITES 
      )
  
      if (!response.data?.success) {
        throw new Error()
      }
      return response.data.data ?? []
    } catch (err) {
      handleApiError('Failed to fetch favorite properties', err)
      return []
    }
  };

  const addFavorite = async (addId: string): Promise<boolean> => {
    try {
      const response = await axiosInstance.post(ENDPOINTS.FAVORITES.ADD_FAVORITE, {
        addId: addId
      })

      return response.data?.success === true
    } catch (err) {
      handleApiError('Failed to add favorite property', err)
      return false
    }
  }

  const deleteFavorite = async (id: number): Promise<boolean> => {
    try {
      const response = await axiosInstance.delete(ENDPOINTS.FAVORITES.REMOVE_FAVORITE, {
        data: { id },
      })

      return response.data?.success === true
    } catch (err) {
      handleApiError('Failed to delete favorite property', err)
      return false
    }
  }

    return {
        loadFavorites,
        addFavorite,
        deleteFavorite
    }
  }
  
export default useFavoritesService
